import React, { useEffect, useState } from "react";
import CommonLayout from "../../../../layouts/commonLayout/CommonLayout";
import CommonNav from "../../../../layouts/commonNav/CommonNav";
import { NavLink, Outlet, useParams } from "react-router-dom";
import baseUrl from "../../../../api/baseUrl";
import "./patientone.scss";
function PatientOne() {
  const { ID } = useParams();
  const [formData, setformData] = useState({
    fullName: "",
    reqNo: "",
  });
  useEffect(() => {
    if (ID) {
      baseUrl
        .get("patient/findById", {
          headers: {
            patientid: ID,
          },
        })
        .then((response) => {
          const item = response.data.data;
          if (ID) {
            setformData({
              fullName: item?.fullName,
              reqNo: item?.regNo,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [ID]);
  return (
    <CommonLayout>
      <CommonNav>
        <div className="patient_nav">
          <div
            className="doctor-select"
        
          >
            <label
              htmlFor=""
              style={{ whiteSpace: "nowrap", color: "#3182ce" }}
            >
              {" "}
              Patient: {formData.fullName}
            </label>
            <div className="select-box">REQ nO: {formData.reqNo}</div>
          </div>
          <div className="patient-routes">
            <NavLink
              to={`general-detail/${ID}`}
              className={({ isActive }) =>
                isActive ? "nav-list nav-list-active" : "nav-list"
              }
            >
              General DETAILS
            </NavLink>

            <NavLink
              to={`examination/${ID}`}
              className={({ isActive }) =>
                isActive ? "nav-list nav-list-active" : "nav-list"
              }
            >
              Examination & Treatments
            </NavLink>

            <NavLink
              to={`Invoices/${ID}`}
              className={({ isActive }) =>
                isActive ? "nav-list nav-list-active" : "nav-list"
              }
            >
              Invoices
            </NavLink>
          </div>
        </div>
      </CommonNav>
      <Outlet />
    </CommonLayout>
  );
}

export default PatientOne;
